import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC025_Request,
  IAPI_FAC025_Response,
} from "../../../type/apiType";
import {
  IAPI_FAC016_Request,
  IAPI_FAC016_Response,
} from "../../../type/apiType";

/**
 * 施設情報の変更登録表示API
 * @return httpChangeFacilityInfo
 */
const httpIAPI_FAC025 = async (
  param: IAPI_FAC025_Request
): Promise<IAPI_FAC025_Response> => {
  let res = await http.post(ApiUrl.API_FAC025, {
    ...param,
  });

  return res.data;
};

/**
 * 契約者氏名等変更届・共済契約証書再交付申出施設情報更新API
 * @return httpFacilitiesJOB17_19Update
 */
const httpIAPI_FAC016 = async (
  param: IAPI_FAC016_Request
): Promise<IAPI_FAC016_Response> => {
  let res = await http.post(ApiUrl.API_FAC016, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_FAC025, httpIAPI_FAC016 };
